<div fxFlexFill fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="5%">
    <div fxFlex fxLayout="row">
        <ng-container *ngIf="item.bgImageUrl; else elseTemplate">
            <img [src]="item.bgImageUrl | safe : 'url'" alt="news image" class="img-fluid" fxFlexFill />
        </ng-container>
        <ng-template #elseTemplate>
            <img src="/assets/images/background_img.jpg" alt="news image" class="img-fluid" fxFlexFill />
        </ng-template>
    </div>
    <div fxFlex fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="start stretch" class="pb-3">
        <span class="pre-headline">{{ item.updatedOn || item.creationDate | date : 'yyyy-MM-dd' }}</span>
        <h2>{{ item.title }}</h2>
        <div fxFlex [innerHTML]="item.content | firstParagraph : 1"></div>
        <a fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center" class="card-link read-more pt-2" routerLink="/home/news/{{ item.contentId }}">
            <mat-icon>trending_flat</mat-icon>
            <span> Read more</span>
        </a>
    </div>
</div>
